import React, { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment";

import PaddedContentArea from "../../../../../common/PaddedContentArea";
import CustomButton from "../../../../../common/CustomButton";

import { CreatePurchaseUsingCoupon } from "../../../../../redux/v2/plan/actions";
import { LoadAccountDetails, SetAccountDetails, } from "../../../../../redux/v2/user/actions";

function MainContent(props) {
    const navigate = useNavigate();

    const [status, setStatus] = useState(0);
    const [code, setCode] = useState("");
    const [date, setDate] = useState(null);
    const [tempAD, setTempAD] = useState(null);

    const codeLength = 5;

    return (
        <PaddedContentArea>
            {status === 0 && (
                <div className="pp-area" id="pp-input-code-area">
                    <h5>Enter Your Promo Code</h5>
                    <input
                        onChange={(e) => {
                            setCode(e.target.value);
                        }}
                    />
                    <div>
                        <CustomButton
                            onClick={async () => {
                                const toastId = toast.loading("Creating purchase...");

                                const res = await props.CreatePurchaseUsingCoupon(code);
                                if (res.status == 200) {
                                    setStatus(1);

                                    setDate(res.date);

                                    localStorage.setItem("requirement_status", props.type == "new" ? 1 : 3);
                                    localStorage.setItem("access-token", localStorage.getItem("temp-access-token"));
                                    localStorage.removeItem("temp-access-token");

                                    const res2 = await props.LoadAccountDetails(true);
                                    setTempAD(res2);
                                    toast.dismiss(toastId);
                                } else if (res.status == 406) {
                                    toast.dismiss(toastId);
                                    setStatus(2);
                                } else if (res.status == 400) {
                                    toast.error("Bad request", {
                                        id: toastId,
                                    });
                                } else {
                                    toast.error("Something went wrong", {
                                        id: toastId,
                                    });
                                }
                            }}
                        >
                            Submit
                        </CustomButton>
                    </div>
                </div>
            )}

            {status === 1 && (
                <div className="pp-area" id="pp-code-success">
                    <h3>Success!</h3>
                    <p>You successfully used a promo code. You have free access to indi until {date ? moment(new Date(date)).format("LL") : ""}.</p>
                    <div>
                        <CustomButton
                            onClick={() => {
                                props.SetAccountDetails(tempAD);
                                props.continue();
                            }}
                        >
                            Continue
                        </CustomButton>
                    </div>
                </div>
            )}

            {status === 2 && (
                <div className="pp-area" id="pp-code-error">
                    <h3>Error</h3>
                    <p>That code "{code}" is either invalid or expired. Please try again or use the X to return to the signup screen.</p>
                    <div>
                        <CustomButton
                            onClick={() => {
                                setStatus(0);
                                setCode("");
                            }}
                        >
                            Retry
                        </CustomButton>
                    </div>
                </div>
            )}
        </PaddedContentArea>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    CreatePurchaseUsingCoupon,
    LoadAccountDetails,
    SetAccountDetails,
})(MainContent);
